/**
 * AWARENESS & REACH objective — Display Network campaigns. Pages in this
 * folder: AwarenessPage (workspace), AwarenessCampaignWizard,
 * CreateAwarenessAdgroup, CreateAwarenessAd. The shared editors, previews and
 * publish helpers live in src/components/google-ads/display/.
 */
import { Sparkles } from 'lucide-react';

export const AWARENESS_BASE = '/google-ads/awareness';
export const AWARENESS_TITLE = 'Awareness & reach';

export const AWARENESS_OBJECTIVE = {
  key: 'awareness',
  title: AWARENESS_TITLE,
  base: AWARENESS_BASE,
  icon: Sparkles,
  subtitle: 'Display campaigns — responsive image ads across millions of sites, apps, Gmail and YouTube',
  goal: 'Brand awareness and reach',
  emptyHint: 'Show your brand to the right people across the Google Display Network. Upload images and a few lines once — Google builds every banner size.',
} as const;
